import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    VendorPaymentsServiceProxy,
    PurchaseTransactionServiceProxy,
    CreateOrEditVendorPaymentDto,
    VendorsServiceProxy,
    FindVendorOutputDto,
    CommonLookupServiceProxy,
    DropDownLookupDto,
    GetVendorForEditInput,
    VendorPaymentItemDto,
    TransactionType,
    PaymentStatus,
    FindCustomerOutputDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';

@Component({
    templateUrl: './create-or-edit-vendorPayment.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditVendorPaymentComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;
    TransactionType = TransactionType;
    paymentStatus = PaymentStatus
    vendorSelectedItem: FindVendorOutputDto;
    filterText = '';
    vendorPayment: CreateOrEditVendorPaymentDto = new CreateOrEditVendorPaymentDto();

    VendorDisplayProperty = '';
    paymentTypeName = '';
    transactions : VendorPaymentItemDto[] = [];
    totalBalance: number;
    balanceAmount: number;
    appliedAmount: number;
    allPaymentTypes: DropDownLookupDto[];
    invId: number = 0;

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('vendorPayment'), '/app/sales/sales/vendorPayments'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _vendorPaymentsServiceProxy: VendorPaymentsServiceProxy,
        private _PurchaseTransactionServiceProxy: PurchaseTransactionServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _vendorService: VendorsServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
       
        if (this._activatedRoute.snapshot.queryParams['vid']) {

            this.invId = this._activatedRoute.snapshot.queryParams['invid'];
            this.vendorPayment.vendorId = this._activatedRoute.snapshot.queryParams['vid'];
            this.vendorPayment.status = PaymentStatus.UnPaid;
            this.vendorPayment.receiptDate = this._dateTimeService.getStartOfDay();
            this._vendorService.getBasicVendorInfo(this.vendorPayment.vendorId)
                .subscribe(resp => {
                    this.vendorSelectedItem = new FindCustomerOutputDto();
                    this.vendorSelectedItem.id = this.vendorPayment.vendorId;
                    this.vendorSelectedItem.displayName = resp.vendorCode + "-" + resp.name;
                    this.fillDropdown();
                    this.getPurchaseTransactions();
                });

        } else {

            this.fillDropdown();
            this.show(this._activatedRoute.snapshot.queryParams['id']);
        }
    }


    allAppliedAmount(): void {

        //this.transactions.forEach(item => {
        //    if (item.allApplied) {
        //        value.appliedAmount = value.balanceAmount;
        //        value.applied = true;
        //    } else {
        //        value.appliedAmount = 0;
        //        value.applied = false;
        //    }
        //});

        /*vm.calculateTotalValue();*/
    }


    applyAmount(data: VendorPaymentItemDto): void {
        if (data.applied) {
            data.appliedAmount = data.balanceAmount;
        } else {
            data.appliedAmount = 0;
        }

        this.calculateTotalValue();
    }

    calculateTotalValue(): void {

        var tempTotBalance = 0;
        var tempTotApplied = 0;

        this.transactions.forEach(val => {
            
            if (val.applied) {
                tempTotApplied += val.appliedAmount;
            }

            tempTotBalance += val.balanceAmount;
        });

       

        this.totalBalance = tempTotBalance;
        this.appliedAmount = tempTotApplied;
        this.balanceAmount = tempTotBalance - tempTotApplied;
        if (this.balanceAmount < 0) {
            this.balanceAmount = 0;
            this.totalBalance = tempTotApplied;
            this.appliedAmount = tempTotApplied;
            this.balanceAmount = this.totalBalance - this.appliedAmount;
        }

        if (this.vendorPayment.paymentDiscount == undefined) this.vendorPayment.paymentDiscount = 0;
        this.vendorPayment.amount = this.appliedAmount - this.vendorPayment.paymentDiscount ;

    }

    show(vendorPaymentId?: number): void {
        if (!vendorPaymentId) {
            this.vendorPayment = new CreateOrEditVendorPaymentDto();
            this.vendorPayment.id = vendorPaymentId;
            this.vendorPayment.status = PaymentStatus.UnPaid;
            this.vendorPayment.receiptDate = this._dateTimeService.getStartOfDay();
            this.vendorPayment.locationId = this.appSession.user.locationId;
            this.VendorDisplayProperty = '';
            this.paymentTypeName = '';

            this.active = true;
        } else {
            this._vendorPaymentsServiceProxy.getVendorPaymentForEdit(vendorPaymentId).subscribe((result) => {
                this.vendorPayment = result.vendorPayment;
                
                this.transactions = result.vendorPaymentItems;
                this.vendorSelectedItem = new FindVendorOutputDto();
                this.vendorSelectedItem.id = this.vendorPayment.vendorId;
                this.vendorSelectedItem.displayName = result.vendorName;
                this.active = true;
                this.calculateTotalValue();
            });
        }
      
    }

    fillDropdown(): void {
        this._commonLookupServiceProxy.getAllPaymentTypesForTableDropdown().subscribe((result) => {
            this.allPaymentTypes = result;
            if (this.vendorPayment.paymentTypeId == undefined) {
                this.vendorPayment.paymentTypeId = null;
            }

        });
    }

    save(status : PaymentStatus): void {
        var input = new GetVendorForEditInput();
        input.vendorPayment = this.vendorPayment;
        input.vendorPayment.status = status;
        input.vendorPaymentItems = this.transactions;
        input.vendorPayment.paymentTypeId = this.vendorPayment.paymentTypeId;
        input.vendorPayment.locationId = this.appSession.user.locationId;
        /*this.vendorPayment.VendorId = this.vendorSelectedItem.id;*/

        if (!(this.vendorPayment.vendorId > 0)) {
            abp.notify.warn('PleaseSelVendor');
            this.saving = false;
            return;
        }
        else if (!(this.vendorPayment.paymentTypeId <= 0)) {
            abp.notify.warn('PleaseSelPaymentType');
            this.saving = false;
            return;
        }
        

        this._vendorPaymentsServiceProxy
            .createOrEdit(input)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.vendorSelectedItem = null;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/purchase/vendorPayments']);
            });
    }

//    saveAndNew(): void {
//        this.saving = true;

//        var input = new GetVendorForEditInput();

//        input.vendorPayment = this.vendorPayment;
//        input.vendorPaymentItems = this.transactions;
        
///*        this.vendorPayment.VendorId = this.vendorSelectedItem.id;*/

//        this._vendorPaymentsServiceProxy
//            .createOrEdit(input)
//            .pipe(
//                finalize(() => {
//                    this.saving = false;
//                }),
//            )
//            .subscribe((x) => {
//                this.saving = false;
               
//                this.notify.info(this.l('SavedSuccessfully'));
//                this.vendorPayment = new CreateOrEditvendorPaymentDto();
//                this.vendorSelectedItem = null;
               
//            });
//    }

    getVendor(Vendor: FindVendorOutputDto) {
        this.vendorPayment.vendorId = Vendor.id;
        this.getPurchaseTransactions();
    }

    getPurchaseTransactions(): void {
        this._PurchaseTransactionServiceProxy.getPurchaseTransactions(
            this.vendorPayment.vendorId, [110, 120, 130, 140], true, null).subscribe((result) => {
                //this.transactions = result;
                console.log(result);
                this.transactions = [];
                result.forEach(val => {
                    var item = new VendorPaymentItemDto();
                    item.transactionNo = val.transactionNo;
                    item.referenceNo = val.referenceNo;
                    item.amount = val.amount;
                    item.balanceAmount = val.balanceAmount;
                    item.applied = this.invId == val.transactionId ? true : false;
                    item.appliedAmount = this.invId == val.transactionId ? val.amount : 0;
                    item.vendorPaymentId = 0;
                    item.transactionDate = val.transactionDate;
                    item.dueDate = val.dueDate;
                    item.transactionId = val.transactionId;
                    item.id = 0;
                    item.type = val.type;
                    this.transactions.push(item);
                });
                this.calculateTotalValue();
            });
       

    }

    goBack(): void {
        this._router.navigate(['/app/sales/vendorPayments']);
    }
}
